
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqGed4w8zZ6z6Wo7mR0cRtoQaBvaxIEL_450z2U9qw_45RXtMMeta } from "/codebuild/output/src3971276767/src/src/pages/faq.vue?macro=true";
import { default as menulud2ZCUOEQXd1qASJYbrtI5yZGND3ReLnic_TyhVnn0Meta } from "/codebuild/output/src3971276767/src/src/pages/menu.vue?macro=true";
import { default as indexFYNRErXVkPQTRBkcWy80yp_o4CVnHB0cTaiqFMEMFsAMeta } from "/codebuild/output/src3971276767/src/src/pages/index.vue?macro=true";
import { default as contactyM0qc37bl1Jb_QauquBnnmw7tOXpIDL4VVcbp5DAaKoMeta } from "/codebuild/output/src3971276767/src/src/pages/contact.vue?macro=true";
import { default as tutorialUFuPkL6Cj8CI3IErYOqhwnn0TpIemd46UYF2RwcGC8YMeta } from "/codebuild/output/src3971276767/src/src/pages/tutorial.vue?macro=true";
import { default as agreementpZql5uxPECdWHJesw2PZSjf6G3mAb7XeApP4wsEzSTkMeta } from "/codebuild/output/src3971276767/src/src/pages/agreement.vue?macro=true";
import { default as about_45passskrxYM2Sve_ih2HbvAI_45u2iju_458_i_45I_oiKvm_kJdf8Meta } from "/codebuild/output/src3971276767/src/src/pages/about-pass.vue?macro=true";
import { default as indexJy7z_45s9vFKIoRrTAM8mQUHcMv9z1LciirewWdTPSNbwMeta } from "/codebuild/output/src3971276767/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93Ug_MQexa5W19A3McMgxN361V_ZidZHLr9iSQdZkdTBoMeta } from "/codebuild/output/src3971276767/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceXt_45zVO6Wz1YGydGH1Gi4Qk4FfmOC0kvwdgG5ZHeZsWIMeta } from "/codebuild/output/src3971276767/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93KymCsDMweUgoFKnQdSrM6nCHm_q0H6k9LaLq8QdW4PQMeta } from "/codebuild/output/src3971276767/src/src/pages/notice/[id].vue?macro=true";
import { default as index_VDOWysa_45tYfQyfsNYk301FPZ4JEpDHZnX8E9dSBQ8gMeta } from "/codebuild/output/src3971276767/src/src/pages/coupon/index.vue?macro=true";
import { default as indexaxkQJ3ba8HX0mazZ_IZLBIlDmFG2Rht5zJ1ynAJ99n4Meta } from "/codebuild/output/src3971276767/src/src/pages/mypage/index.vue?macro=true";
import { default as indexBqC_45Lm0ZoVc9JssYoHVKjUPRhoiHvMHqjCjKVc0eMPoMeta } from "/codebuild/output/src3971276767/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93YGjwK7k_456ZtpgSGu6oNYH_451766ybIOQe53JvMlyhr5EMeta } from "/codebuild/output/src3971276767/src/src/pages/parking/[id].vue?macro=true";
import { default as index_45FIWmUbKsvnmRleZO5w6DSEvungJMNtqYw38GfWMybsMeta } from "/codebuild/output/src3971276767/src/src/pages/history/index.vue?macro=true";
import { default as indexTQKviqRYFlwlUOjxKv1GhsrhVieALu3RwVf5rmYY2QkMeta } from "/codebuild/output/src3971276767/src/src/pages/monthly/index.vue?macro=true";
import { default as indexppJSCBHJ4VosktaZ0E50mzFZgZicd7PDYLWtDNn_wBkMeta } from "/codebuild/output/src3971276767/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexg_mBQ4r7ixhNksAh9YWfnpKByqo5tGxg0WoQ_VoY6D4Meta } from "/codebuild/output/src3971276767/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavipGhNi1gxWwU01yRaiXwFBkgG7Zlhsx2ZUCMOTKKXPUIMeta } from "/codebuild/output/src3971276767/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit0y9fLXZtnX5pGcwHUig8yQakxR15PVjzvvt3TyXit6EMeta } from "/codebuild/output/src3971276767/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreement2waJmoMcjNwopfhwQj6OozN1d3p_DGmHMii3eaP_DJsMeta } from "/codebuild/output/src3971276767/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexKxvVuE_45sIFeVsVgCyW4GdqLxVBfBBpRBgyHv73eqydkMeta } from "/codebuild/output/src3971276767/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453d84qNUu39W4_45XLK2EYZgMIMTQrkQWTa7ZU9ZIA_451Q1zkMeta } from "/codebuild/output/src3971276767/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmDS7hH4kByMtDm4lJ_45PZquA5V7F_456_45ItwctwEBYbgFXIMeta } from "/codebuild/output/src3971276767/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexbH1u2Y8fed1wTPyEeXe1S7tEnR31wEaqJDngogyBcj0Meta } from "/codebuild/output/src3971276767/src/src/pages/card/create/index.vue?macro=true";
import { default as indexGe6FO2psPDZrSVIbt8a2V8cI_cQ83xqTmU_45_jIpF_kgMeta } from "/codebuild/output/src3971276767/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirm5X2zMr_454vdqmAjHmXx4w9DzIMeQ7taCdmtr5B4Vs5vIMeta } from "/codebuild/output/src3971276767/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmK7mRs0_45LoKbMoI0zDmKFFHCDCG_45x2LrxANyCsoKDZyoMeta } from "/codebuild/output/src3971276767/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completegRYoi6EMbJQqV9_HVWYSxmU9FIdw2t3ENrmAlHeuSEwMeta } from "/codebuild/output/src3971276767/src/src/pages/membership/complete.vue?macro=true";
import { default as registerETgtsKwcDJfH9OiZ2BcDqZPxElRQKcJMmm_DD5KKF_45QMeta } from "/codebuild/output/src3971276767/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93s_45KBc3yNCB4LR43rr6A139aUV3avO12WnUYnGpLLWIkMeta } from "/codebuild/output/src3971276767/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirm38oNLPUpGmF1CdRJ8t3ErkzFUpPnmZD1GZosx0Irqh0Meta } from "/codebuild/output/src3971276767/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93GclhdaYnkggy3FAIOqunEQNg6woM9pR_45hGxk_45lU_2boMeta } from "/codebuild/output/src3971276767/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexdN3jmSjnwtflEYls34GZ5CS5ENKpybXJJobm16feyAYMeta } from "/codebuild/output/src3971276767/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeYsEpFIApgez6x61ScGLW_45vuEvl_456eV39VylJJXwb26MMeta } from "/codebuild/output/src3971276767/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codejYHvo8oRVyaXeE_45gscoW_45C9twmzB3vve9tEWrplz9jwMeta } from "/codebuild/output/src3971276767/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeM1VhMU2fFBTvK40JVuChwyFTVvwQ0HzP5PYre0vjQU4Meta } from "/codebuild/output/src3971276767/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerkx1yPO_45WobZ_f_45lFi1yGq7GOWJTGzeuSMOgVltMYzcgMeta } from "/codebuild/output/src3971276767/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete7uu33dVIQ4JUxj_45VsIiVvDyKd7XcrGu0aPdOOjNls2sMeta } from "/codebuild/output/src3971276767/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexFFcvjAq0H72I2NtbVu7sO4ozwlBsJEyEs8IeVw_45gCh4Meta } from "/codebuild/output/src3971276767/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmWchTmdXytRY__h9jLm4xc7Hi6oPqyrviIdsAKs8N56YMeta } from "/codebuild/output/src3971276767/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeRp4RQxsG4X_45IOSZxEWb_456VR9CwTgMxtx9pO6dOW9xlsMeta } from "/codebuild/output/src3971276767/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexwaYNPWiCJ_Pho_DrX6_QpA3eFY4w_l1uTcpKYcnKkvsMeta } from "/codebuild/output/src3971276767/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93ZT0jAPQ4o7BsUHgyAI0K90RxS3Wp4eiFK2NXwl8sqZYMeta } from "/codebuild/output/src3971276767/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete_4JfxG8JsyfquYTAqkFhiKZTQkWAlFW_0KEERYF60qAMeta } from "/codebuild/output/src3971276767/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasShMNGP7D8hkTqOTzW_0w6hL_LWDySdcYL32Zih_45V2M0Meta } from "/codebuild/output/src3971276767/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as sampleNKZ19KS9I_45C8rr2ZOEELHq6orjDGKQX1rMqWsNVniy0Meta } from "/codebuild/output/src3971276767/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailEtNxknUt_RnJawkc7MmwX1tgVZSpVIy9kBElG_45um_6UMeta } from "/codebuild/output/src3971276767/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmpOB7f2fURx7KTIt8FpYSay5JsQSSi9KoxMMcCbmIm3IMeta } from "/codebuild/output/src3971276767/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentBC2mewdZrl8TpvSsb0LYWPpWlIgQ4vyRo6vgWtT7Jo4Meta } from "/codebuild/output/src3971276767/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmqYLg2i4Q7q63Xd7z_pAqO1onIi9WCZTFSRcXzU3mh2AMeta } from "/codebuild/output/src3971276767/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedatehCRZUUxpUmLRC6szOcgCdLVjXueGT_45G5w_hyq_Ssp3wMeta } from "/codebuild/output/src3971276767/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeMG7VA8n1GRUAWdcJQAbKO_451njGq_45Vl5w24cfF_45iaKi0Meta } from "/codebuild/output/src3971276767/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45code10jBYIsiBAg86ueGsSfFBQh3UVkysFRfc1nHwWg_45640Meta } from "/codebuild/output/src3971276767/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45password0N_45a_454483S9CpTG5qjF4qsdvd3rXB3PfXlZsLWsMIikMeta } from "/codebuild/output/src3971276767/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasneS4w11oVb4gj6sQq8izhW7_45XvPBdZOTW7l1U01BJwYMeta } from "/codebuild/output/src3971276767/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerZfLSZRoMfmT_tvN8Zgbhygz3PGVyxVoxjIJ33JPZsaIMeta } from "/codebuild/output/src3971276767/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codei9FuPFJNiouoD8Nyx5yaD5mRi_2XQ1pu8hY2KwA01CwMeta } from "/codebuild/output/src3971276767/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexFfwe63xeSCdysup0EtK29NSVBbIGHt2J9tQXsGHlfw4Meta } from "/codebuild/output/src3971276767/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexxOXzx5X4_45NBGmbaRAnlgqryn2veTo_aX_hPmksAgLTQMeta } from "/codebuild/output/src3971276767/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexHmkrPkbQ9EdoPqGQuBlSqA0EqnQ_45FpAhtRTDGEthdZUMeta } from "/codebuild/output/src3971276767/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexsw7nzla8CBRu22d3Oq4rl9oZh8TJq7rde9tmTgtN6ekMeta } from "/codebuild/output/src3971276767/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateGrIf7Z52g1vWZSRxtWsVdihdaqYp_i2qOgS6xrz56_4Meta } from "/codebuild/output/src3971276767/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeS9yB4g4SNUsjDqFKPSdU9H1qEBKWpcsrGyhD2itbmuAMeta } from "/codebuild/output/src3971276767/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmPNv7us_zI3ud7C49NTlHxj58eylouP0hVmxbksW9DGgMeta } from "/codebuild/output/src3971276767/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as index9ur0NUZ8_45XmiK0WVWE1sr_y2otNd7PVI5SiKLRB7aQIMeta } from "/codebuild/output/src3971276767/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeBDixddCBBS9VObpo1ITZAVtdzpPERi1bt_45pfKQSt3sYMeta } from "/codebuild/output/src3971276767/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update90ur3059ti9X4s7hDuk9Bssk8SSBP7GskRNQW7teIKIMeta } from "/codebuild/output/src3971276767/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexivhi3E0muRbM2XfV9xRXvX32CfCiX_45oKLVOBFEGCZOoMeta } from "/codebuild/output/src3971276767/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as index7GCOFmbnABXROtoUvF4c24ujMr_IRcAuER5wBMLDmJcMeta } from "/codebuild/output/src3971276767/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completego19hSFCujTHWVggrYAxnJJRWZoYDZJ62tvRGDetKuYMeta } from "/codebuild/output/src3971276767/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexmauKtfNXXLPPeyH4pSUBvurp_45L3fzNF2lmKasDKQ7zYMeta } from "/codebuild/output/src3971276767/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codexdrit5PZ_45nvDbZ6ixdG7FP1Ik6LRBR0uG14vCSYpBWcMeta } from "/codebuild/output/src3971276767/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexNkvaCR9n7UKIy_45htOlgzkZlPuMKdWyNejW1_lBAz5VEMeta } from "/codebuild/output/src3971276767/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexnm7ebhk23tf2_45ASBUpwGu5YpqMmH_45JA3oemvVJVFihMMeta } from "/codebuild/output/src3971276767/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexNcIGYHeUT_45fF3rUI9CDw9Mr7Mz17QluRuPUargnqqu8Meta } from "/codebuild/output/src3971276767/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as update20ILo_45vYqIJy7hpnhUUA_yZSzEedOOQAw3kM8ugqx48Meta } from "/codebuild/output/src3971276767/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmwFX20slBogVSHH8DW2m06PnxfxoPy5Sycu0JSIp45SUMeta } from "/codebuild/output/src3971276767/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menulud2ZCUOEQXd1qASJYbrtI5yZGND3ReLnic_TyhVnn0Meta || {},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexFYNRErXVkPQTRBkcWy80yp_o4CVnHB0cTaiqFMEMFsAMeta || {},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index_VDOWysa_45tYfQyfsNYk301FPZ4JEpDHZnX8E9dSBQ8gMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3971276767/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index_45FIWmUbKsvnmRleZO5w6DSEvungJMNtqYw38GfWMybsMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3971276767/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexppJSCBHJ4VosktaZ0E50mzFZgZicd7PDYLWtDNn_wBkMeta || {},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexg_mBQ4r7ixhNksAh9YWfnpKByqo5tGxg0WoQ_VoY6D4Meta || {},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexbH1u2Y8fed1wTPyEeXe1S7tEnR31wEaqJDngogyBcj0Meta || {},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirm5X2zMr_454vdqmAjHmXx4w9DzIMeQ7taCdmtr5B4Vs5vIMeta || {},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmK7mRs0_45LoKbMoI0zDmKFFHCDCG_45x2LrxANyCsoKDZyoMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3971276767/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completegRYoi6EMbJQqV9_HVWYSxmU9FIdw2t3ENrmAlHeuSEwMeta || {},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerETgtsKwcDJfH9OiZ2BcDqZPxElRQKcJMmm_DD5KKF_45QMeta || {},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirm38oNLPUpGmF1CdRJ8t3ErkzFUpPnmZD1GZosx0Irqh0Meta || {},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeYsEpFIApgez6x61ScGLW_45vuEvl_456eV39VylJJXwb26MMeta || {},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codejYHvo8oRVyaXeE_45gscoW_45C9twmzB3vve9tEWrplz9jwMeta || {},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeM1VhMU2fFBTvK40JVuChwyFTVvwQ0HzP5PYre0vjQU4Meta || {},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerkx1yPO_45WobZ_f_45lFi1yGq7GOWJTGzeuSMOgVltMYzcgMeta || {},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmWchTmdXytRY__h9jLm4xc7Hi6oPqyrviIdsAKs8N56YMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeRp4RQxsG4X_45IOSZxEWb_456VR9CwTgMxtx9pO6dOW9xlsMeta || {},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexwaYNPWiCJ_Pho_DrX6_QpA3eFY4w_l1uTcpKYcnKkvsMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete_4JfxG8JsyfquYTAqkFhiKZTQkWAlFW_0KEERYF60qAMeta || {},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(sampleNKZ19KS9I_45C8rr2ZOEELHq6orjDGKQX1rMqWsNVniy0Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailEtNxknUt_RnJawkc7MmwX1tgVZSpVIy9kBElG_45um_6UMeta || {},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmpOB7f2fURx7KTIt8FpYSay5JsQSSi9KoxMMcCbmIm3IMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentBC2mewdZrl8TpvSsb0LYWPpWlIgQ4vyRo6vgWtT7Jo4Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmqYLg2i4Q7q63Xd7z_pAqO1onIi9WCZTFSRcXzU3mh2AMeta || {},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeMG7VA8n1GRUAWdcJQAbKO_451njGq_45Vl5w24cfF_45iaKi0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45code10jBYIsiBAg86ueGsSfFBQh3UVkysFRfc1nHwWg_45640Meta || {},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45password0N_45a_454483S9CpTG5qjF4qsdvd3rXB3PfXlZsLWsMIikMeta || {},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerZfLSZRoMfmT_tvN8Zgbhygz3PGVyxVoxjIJ33JPZsaIMeta || {},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codei9FuPFJNiouoD8Nyx5yaD5mRi_2XQ1pu8hY2KwA01CwMeta || {},
    component: () => import("/codebuild/output/src3971276767/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3971276767/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]